import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { BUTTON_OFF, BUTTON_ON } from '../../../../constants'
import { hotelTypeFieldName, ICON_BUSINESS, ICON_FAMILY } from '../constants'
import IconField from './IconField'

class HotelType extends Component {
  hotelTypeValue = type => (this.props.hotelType === type ? BUTTON_ON : BUTTON_OFF)

  render() {
    const {
      titles: { title, icons: iconTitles },
      onTypeChange,
      hotelType,
      eventTrackingData,
    } = this.props
    return (
      <div className="hotel-type">
        <div className="hotel-type__title">
          {title}
        </div>
        <div className="hotel-type__items">
          {[ICON_BUSINESS, ICON_FAMILY].map((iconId, key) => (
            <Field
              key={key}
              name={hotelTypeFieldName(iconId)}
              component={IconField}
              onChange={onTypeChange}
              props={{
                iconId,
                titles: iconTitles,
                value: this.hotelTypeValue(iconId),
                activeHotelType: hotelType,
                eventTrackingData,
              }}
            />
          ))}
        </div>
      </div>
    )
  }
}

HotelType.propTypes = {
  titles: PropTypes.shape({
    title: PropTypes.string,
    icons: PropTypes.shape({
      business: PropTypes.string,
      family: PropTypes.string,
    }),
  }),
  hotelType: PropTypes.string,
  onTypeChange: PropTypes.func.isRequired,
  eventTrackingData: PropTypes.arrayOf(String),
}

HotelType.defaultProps = {
  titles: [],
  hotelType: '',
  eventTrackingData: [],
}

export default HotelType
